import React from 'react';
import './Equalizer.css';
import imageSrc from '../icon/CarbonFootprintReduction.jpg'; // ✅ Replace with your image

const Equalizer = () => {
  return (
    <div className="equalizer-wrapper">
      <svg viewBox="0 0 473 518" className="masked-svg">
        <defs>
          <mask id="barMask">
            <rect width="100%" height="100%" fill="black" />
            <rect className="bar-svg bar1" x="20" width="70" rx="40" ry="40" fill="white" />
            <rect className="bar-svg bar2" x="100" width="70" rx="40" ry="40" fill="white" />
            <rect className="bar-svg bar3" x="180" width="70" rx="40" ry="40" fill="white" />
            <rect className="bar-svg bar4" x="260" width="70" rx="40" ry="40" fill="white" />
            <rect className="bar-svg bar5" x="340" width="70" rx="40" ry="40" fill="white" />
          </mask>
        </defs>

        <image
          href={imageSrc}
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          mask="url(#barMask)"
        />
      </svg>
    </div>
  );
};


export default Equalizer;
